/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
// TODO fix and remove eslint disables
import { db } from '../Firebase';
import { collection as fbCollection, query, orderBy, setDoc, doc, updateDoc } from 'firebase/firestore';
import { collection } from 'rxfire/firestore';
import { map, tap, shareReplay, switchMap } from 'rxjs/operators';
import { combineLatest } from 'rxjs';
import { CardT } from '../shared/codecs/Card';
import {} from './CardProps';
import { authed_user } from '../Users/observables';
import { decodeThrowing } from '../shared/firebase/decodeHelper';
import { sendEventToFirebase } from '../logging/events';
export const cards_collection = authed_user.pipe(map(user => fbCollection(db, 'organizations', user.organization, 'cards')), shareReplay(1));
export const cards = cards_collection.pipe(switchMap(cards_collection => {
    return collection(query(cards_collection, orderBy('heading'))).pipe(map((cards) => cards
        .map(card => (Object.assign({ id: card.id }, decodeThrowing(CardT, card.data()))))
        .filter(card => !card.deleted)), tap(cards => console.log(`cards ${cards.length}`)), shareReplay(1));
}), shareReplay(1));
export const card_count = cards.pipe(map(cards => cards.length), tap(count => console.log(`card_count ${count}`)), shareReplay(1));
export const set_card = combineLatest([
    cards_collection,
    authed_user,
]).pipe(map(([collection, authed_user]) => {
    return async (card) => {
        if (card.id) {
            console.log(`Submitting a card with id: ${card.id}`);
            return setDoc(doc(collection, card.id), card);
        }
        else {
            console.log('Adding a new card');
            const newDoc = doc(collection);
            await setDoc(newDoc, Object.assign(Object.assign({}, card), { id: newDoc.id }));
            return sendEventToFirebase({
                key: 'AddCard',
                organization: authed_user.organization,
            });
        }
    };
}), shareReplay(1));
export const delete_card = cards_collection.pipe(map(collection => {
    return async (id) => {
        const toDelete = doc(collection, id);
        return updateDoc(toDelete, { deleted: true });
    };
}), shareReplay(1));
